import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import renderEnvComponent from 'data/common/renderEnvComponent';

class Brands extends PureComponent {
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return <div>lala</div>;
    }
}

const styles = theme => ({});
export default withRouter(renderEnvComponent('scenes/Brands/index')(withStyles(styles, { withTheme: true })(Brands)));



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Brands/index.js